function mapStateToRowProps(state, test) {
  return {
    expandedRows: state.app.expandedRows,
  };
}

export default mapStateToRowProps;
